import React from 'react';
import './BlogPost.css';

import logo from '../../images/2021-freibad.jpg';

class BlogPost4 extends React.Component {
  render() {
    return (
    <div className="blogpost-outer">
      <div className="blogpost-title">
        <h3 className="blogpost-h3" >Grillevent im Freibad!     -     4. September 2021</h3>
      </div>
      <div className="blogpost-content">
        <div className="blogpost-image">
          <img className="image-fit" alt="Grillevent im Freibad" src={logo}/>
        </div>
        <div className="blogpost-text">
          Nachdem wir bereits mit der Nico-Mey Big Band das Freibad Alstätte beschallen durften, haben wir uns alle Mühe gegeben, mit der Tanzband ab 23:00 Uhr noch einmal richtig einzuheizen. Es war eine super Sause. 
          <p>Dafür hat sich das lange Warten gelohnt!</p>
        </div>

      </div>
    </div>
    )
  }
}

export default BlogPost4;


// WEBPACK FOOTER //
// ./src/components/blog/BlogPost6.js